<template>
  <div class="container">
    <h1>
      This page does not exist.
    </h1>
    <router-link to="/login">Go to login page</router-link>
  </div>
</template>

<script>
  export default {
    name: "404",
    data() {
      return {

      }
    }
  }
</script>
